import React from "react";
import "./EvaluationPopup.css";
import { useNavigate } from "react-router-dom";
import EvaluationService from "../../Services/EvaluationService";
import secureLocalStorage from "react-secure-storage";
import DataParser from "../../utlits/Dataparser";

const EvaluationPopup = ({ data, onClose }) => {
  const navigate = useNavigate();

  const adminInfo = JSON.parse(secureLocalStorage.getItem("adminInfo"));
  const headId = adminInfo?.user?.userdata?.id;
  const companyId = adminInfo?.user?.userdata?.company_id;

  const { hasPending, hasPastPending, canSkip, screenBlocked } = data;

  const isMandatory = screenBlocked;

  return (
    <div className={`evaluation-popup ${screenBlocked ? "screen-blocker" : ""}`}>
      <div className="popup-content">
        <h3>Performance Evaluation Pending</h3>
        <p>
          {hasPastPending
            ? "You have pending performance evaluations from past periods. These are mandatory and must be completed to continue."
            : "You have pending performance evaluations that require your attention."}
          {isMandatory && !hasPastPending ? " Please complete them to continue using the system." : ""}
          {!isMandatory ? " Kindly complete them at your earliest convenience." : ""}
        </p>

        <button onClick={async () => {
          // Treat visiting the page as a "skip" for the day to suppress popup
          await EvaluationService.skipEvaluation({
            head_id: headId,
            company_id: companyId,
            period_start: data.periodStart || "all",
            period_end: data.periodEnd || "all"
          });
          navigate(`/${DataParser.CompanyIdentifierRole()}/evaluation`);
          onClose();
        }}>
          Evaluate Now
        </button>
      </div>
    </div>
  );
};

export default EvaluationPopup;
